import { render } from "./MobileNotesPage.vue?vue&type=template&id=632bc431"
import script from "./MobileNotesPage.vue?vue&type=script&lang=js"
export * from "./MobileNotesPage.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__